<template>
  <div id="app">
    <el-main class="el-main">
      <router-view></router-view>
    </el-main>
  </div>
</template>

<script>
import utils from '@/assets/js/utils.js';
export default {
  name: 'app',
  created() {
    // url上截取domain
    let localUrl = window.location.href;
    let str1 = localUrl.split('.')[1];
    let str2 = localUrl.split('.')[2].split('/')[0];
    let domainName = `.${str1}.${str2}`;

    let cookie = utils.getCookie('loginKey');

    if (cookie) {
      this.axios
        .get('/userGroup/user-group/rgUser/autoSignIn', {})
        .then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              let result = res.data.result;
              if (domainName) {
                window.document.cookie = `path=/;domain=${domainName}}`;
                if (result.tagList && result.tagList.length) {
                  result.tagList.forEach((itm) => {
                    window.document.cookie = `${itm.tagKey}=${itm.tagValue};path=/;domain=${domainName};}`;
                  });
                }
              }
              if (result.redirectUrl) {
                let url =
                  result.redirectUrl.indexOf('http') == 0 ? result.redirectUrl : 'http://' + result.redirectUrl;
                window.location.href = url;
                // 通知gridlink登录成功
                window.webkit.messageHandlers.hideNavIfLogin.postMessage(JSON.stringify({}))
              }
            }
          } else {
            this.$message.error('request failed');
          }
        });
    }
    // window.location.href = window.location.protocol + '//' + this.StateObj.common.baseUrl.tvuccUrl;
  },
};
</script>

<style lang="less"></style>
